<script setup lang="ts">
type TagVariant = 'regular' | 'ratings';
type TagSize = 'medium' | 'large';

const props = withDefaults(
  defineProps<{
    variant?: TagVariant
    size?: TagSize
    text?: string
    tag?: 'span' | 'li' | (string & {})
  }>(), {
    variant: 'regular',
    size: 'medium',
    tag: 'span',
  },
);

const activeClasses: Record<TagVariant, string> = {
  regular: `rounded-lg font-semibold bg-secondary text-white`,
  ratings: `rounded-lg font-semibold bg-rating`,
} as const;
const sizeClasses: Record<TagSize, string> = {
  medium: 'text-xs',
  large: 'font-title text-xl',
};
const classes = computed(() => {
  return [
    activeClasses[props.variant],
    sizeClasses[props.size],
  ];
});
</script>

<template>
  <component
    :is="tag"
    class="px-xs py-2xs inline"
    :class="classes"
  >
    {{ text }}
  </component>
</template>
